import toString from './to-string';

const upperFirst = function(value: string): string {
  const str = toString(value);
  return str.charAt(0).toUpperCase() + str.substring(1);
};

export default upperFirst;
